import React, { useRef, useEffect } from 'react';
import '@yaireo/tagify/dist/tagify.css';
import Tagify from '@yaireo/tagify';
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal';

const TagifyInput = ({
  label,
  placeholder,
  isTooltipRequired,
  tooltip,
  value,
  fieldName,
  formik,
  isDisabled,
}: any) => {
  const inputRef = useRef<any>(null);
  const tagifyRef = useRef<any>(null); // Store Tagify instance

  useEffect(() => {
    if (inputRef.current) {
      // Destroy existing instance if it exists
      if (tagifyRef.current) {
        tagifyRef.current.destroy();
      }

      // Initialize new Tagify instance
      tagifyRef.current = new Tagify(inputRef.current, {
        editTags: isDisabled ? false : 1,
        readonly: isDisabled,
      });
      let tagValues = formik.values[fieldName];

      // Ensure tagValues is always an array
      if (!Array.isArray(tagValues)) {
        tagValues = typeof tagValues === 'string' ? tagValues.split(',') : [];
      }

      // Populate Tagify with tags
      if (tagValues.length > tagifyRef.current.value.length) {
        tagifyRef.current.addTags(tagValues);
      }
      // Handle input change
      tagifyRef.current.on('change', (e: any) => {
        try {
          const parsedValue = JSON.parse(e.detail.value);
          const tagValues = parsedValue.map((tag: any) => tag.value).join(',');
          formik.setFieldValue(fieldName, tagValues || '');
        } catch (err) {
          formik.setFieldValue(fieldName, '');
          console.warn('Tagify value is not valid JSON:', e.detail.value);
        }
      });

      return () => {

        tagifyRef.current.destroy();

      };
    }
  }, [formik.values[fieldName], isDisabled]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <label className='form-label font-size-13 text-dark ms-md-0 d-flex flex-md-row align-items-md-center'>
        {label}
        {isTooltipRequired && <ToolTipUIForModal tooltipText={tooltip} />}
      </label>
      <input
        name={fieldName}
        className={`form-control border`}
        ref={inputRef}
        type='text'
        placeholder={placeholder}
      />
    </div>
  );
};

export default TagifyInput;
